#define GLSLIFY 1
float exponentialInOut(float t) {
  return t == 0.0 || t == 1.0
    ? t
    : t < 0.5
      ? +0.5 * pow(2.0, (20.0 * t) - 10.0)
      : -0.5 * pow(2.0, 10.0 - (t * 20.0)) + 1.0;
}

attribute vec2 instanceOffset;

uniform float uElapsed;
uniform float uScale;
uniform float uSpin;
uniform float uThickness;
uniform float uRadius;
uniform float uTwist;
uniform float uTilt;
uniform float uPivot;
uniform float uSpeed;
uniform float uFade;
uniform float uLoops;
uniform float uCount;
uniform vec2 uPosition;
uniform vec2 uRotation;

varying float vIdOffset;
varying float vFog;
varying float vDistance;
varying vec2 vUv;
varying vec3 vObjectNormal;
varying vec2 vUvOffset;
varying vec2 vNextUvOffset;

const float PI = 3.141592653589793;

// prettier-ignore
mat4 rotateX(float radians) {
    float c = cos(radians);
    float s = sin(radians);

    return mat4(
    1.0, 0.0, 0.0, 0.0,
    0.0, c, -s, 0.0,
    0.0, s, c, 0.0,
    0.0, 0.0, 0.0, 1.0
    );
}

// prettier-ignore
mat4 rotateY(float radians) {
    float c = cos(radians);
    float s = sin(radians);

    return mat4(
    c, 0.0, s, 0.0,
    0.0, 1.0, 0.0, 0.0,
    -s, 0.0, c, 0.0,
    0.0, 0.0, 0.0, 1.0
    );
}

// prettier-ignore
mat4 rotateZ(float radians){
    float c = cos(radians);
    float s = sin(radians);

    return mat4(
    c, -s, 0.0, 0.0,
    s, c, 0.0, 0.0,
    0.0, 0.0, 1.0, 0.0,
    0.0, 0.0, 0.0, 1.0
    );
}

// prettier-ignore
mat4 scale(float s){
    return mat4(
    s, 0.0, 0.0, 0.0,
    0.0, s, 0.0, 0.0,
    0.0, 0.0, s, 0.0,
    0.0, 0.0, 0.0, 1.0
    );
}

// prettier-ignore
mat4 scaleX(float s){
    return mat4(
    s, 0.0, 0.0, 0.0,
    0.0, 1.0, 0.0, 0.0,
    0.0, 0.0, 1.0, 0.0,
    0.0, 0.0, 0.0, 1.0
    );
}

// prettier-ignore
mat4 translateXY(vec2 p){
    return mat4(
    1.0, 0.0, 0.0, 0.0,
    0.0, 1.0, 0.0, 0.0,
    0.0, 0.0, 1.0, 0.0,
    p.x, p.y, 0.0, 1.0
    );
}

// prettier-ignore
mat4 translateXZ(vec2 p){
    return mat4(
    1.0, 0.0, 0.0, 0.0,
    0.0, 1.0, 0.0, 0.0,
    0.0, 0.0, 1.0, 0.0,
    p.x, 0.0, p.y, 1.0
    );
}

vec2 pointOnCircle(float radius, float angle) {
  return vec2(cos(angle) * radius, sin(angle) * radius);
}

void main() {
  float instanceId = float(gl_InstanceID);
  float offset = instanceId / uCount;
  float e = fract(offset + uSpin);
  float t = e * 2.0 - 1.0;
  float a = abs(e - 0.5) * 2.0;

  mat4 transformedMatrix =
    instanceMatrix *
    scale(uScale) *
    translateXY(vec2(uPosition.x, uPosition.y * -1.0)) *
    rotateX(uRotation.y) *
    rotateZ(uRotation.x) *
    rotateY(uSpeed) *
    translateXZ(pointOnCircle(uRadius, offset * PI * 2.0)) *
    rotateY(offset * PI * 2.0 + PI * 0.5) *
    rotateZ(uTilt) *
    translateXY(vec2(0.0, uPivot * 1.0)) *
    rotateX(PI * t * uLoops * uTwist) *
    translateXY(vec2(0.0, uPivot * -1.0)) *
    scaleX(uThickness * 0.05);

  vUv = uv;
  float index = mod(instanceId - uFade, uCount);
  float imageIndex = index / uCount * 4.0;
  vIdOffset = exponentialInOut(fract(imageIndex));

  float imageId = floor(imageIndex);
  float nextImageId = mod(imageId + 1.0, 4.0);

  vUvOffset = vec2(mod(imageId, 2.0), floor(imageId * 0.5)) * 0.5;
  vNextUvOffset = vec2(mod(nextImageId, 2.0), floor(nextImageId * 0.5)) * 0.5;

  vObjectNormal = normal;

  vec3 pos = (transformedMatrix * vec4(position, 1.0)).xyz;
  vec4 mvPosition = modelViewMatrix * vec4(pos, 1.0);
  vDistance = distance(mvPosition.xyz, vec3(0.0, 0.0, 5.0));

  gl_Position = projectionMatrix * mvPosition;
}
